import { Component, Input } from '@angular/core';
import { InvoiceStatus, VisibilityStatus } from '../../../../core/interfaces/invoice-interfaces';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-invoice-status-text',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './invoice-status-text.component.html',
  styleUrl: './invoice-status-text.component.css'
})
export class InvoiceStatusTextComponent {
  InvoiceStatus = InvoiceStatus;
  VisibilityStatus = VisibilityStatus;

  @Input() invoiceStatus: InvoiceStatus = InvoiceStatus.ERROR;
  @Input() visibilityStatus: VisibilityStatus = VisibilityStatus.READY_FOR_USER;
}
